const contactRoute = [
  {
    path: '/contact',
    component: () => import('@/views/contact/index.vue'),
    redirect: '/contact/map',
    meta: {
      title: '联系我们',
      breadcrumb: true,
      layout: 'DefaultLayout'
    },
    children: [
      {
        path: 'map',
        component: () => import('@/views/contact/ContactMap.vue'),
        meta: {
          title: '联系方式',
          breadcrumb: true,
        },
      },
      {
        path: 'message',
        component: () => import('@/views/contact/ContactMessage.vue'),
        meta: {
          title: '在线留言',
          breadcrumb: true,
        },
      }
    ]
  }
]
export default contactRoute
